import { api } from '../../api/api';

export type FicDashboardSummaryStatus =
  | 'available'
  | 'partial'
  | 'empty'
  | 'unavailable'
  | 'error';

export interface FicDashboardSummary {
  fic: {
    id: number;
    operationId: string | null;
    name: string | null;
    cnpj?: string | null;
    slug?: string | null;
  };
  persistedFidcCount: number;
  totalMonitoredFundsCount: number;
  netEquity: number | null;
  top5: {
    percentageOfFicNetEquity: number | null;
    alertFundCount: number | null;
  };
  alertBreakdown: {
    critical: number | null;
    attention: number | null;
    none: number | null;
  };
  status: FicDashboardSummaryStatus;
  reason: string;
}

export interface FicDashboardSummaryResponse {
  data: FicDashboardSummary[];
  meta: {
    status: FicDashboardSummaryStatus;
    reason: string;
    cardsCount: number;
    competence: string | null;
  };
}

export async function getFicDashboardSummary(
  date?: string,
): Promise<FicDashboardSummaryResponse> {
  const { data } = await api.get<FicDashboardSummaryResponse>(
    '/wallet/followed-funds/dashboard-summary',
    { params: date ? { date } : undefined },
  );

  return data;
}
